import "best-common-react/lib/styles/bcr.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./App.css";
import "./assets/fonts/Roboto-Bold.ttf";
import "./assets/fonts/Roboto-Italic.ttf";
import "./assets/fonts/Roboto-Regular.ttf";
import "./assets/fonts/RobotoCondensed-Bold.ttf";
import "./assets/fonts/RobotoCondensed-Italic-VariableFont_wght.ttf";
import "./assets/fonts/RobotoCondensed-Light.ttf";
import "./assets/fonts/RobotoCondensed-VariableFont_wght.ttf";
import WrapperProvider from "./modules/WrapperProvider";
import { CookieConstants } from "./constants/CookieConstants";
import { LocalStorageConstants } from "./constants/LocalStorageConstants";
import Cookies from "js-cookie";

const container = document.getElementById("frontend-starter-app");
const root = createRoot(container);

const targetScript = window.MLBBest.envVariables.ADOBE_TARGET_SCRIPT;
if (targetScript) {
  const script = document.createElement("script");
  script.src = targetScript;
  script.async = true;
  document.head.appendChild(script);
}

const cookieValue = Cookies.get(CookieConstants.MILBHUB_BLUE_COOKIE);
if (cookieValue) {
  localStorage.setItem(LocalStorageConstants.OKTA_TOKEN, cookieValue);
}

window.addEventListener("message", (event) => {
  if (event.data.type === "okta-auth-state" && event.origin.includes(".mlbinfra.com")) {
    console.log(event);
    const local_okta_token = localStorage.getItem(LocalStorageConstants.OKTA_TOKEN);
    if (local_okta_token === null || local_okta_token === "{}") {
      localStorage.setItem(LocalStorageConstants.OKTA_TOKEN, event.data.data);
      window.location.reload();
    }
  }
});

root.render(
  <WrapperProvider>
    <App />
  </WrapperProvider>,
);
